import React from 'react';
import Visitors from '../../components/visitors/VisitorContainer';

export default function VisitorsPage() {
  React.useEffect(() => {
    document.title = "PromoShems - Visiteurs"
    return () => {
      document.title = "PromoShems"
    };
  }, []);
  return (
    <Visitors />
  );
}
